// Export all sample education data
export { allInOneData } from './all-in-one-data';
export { overview } from './overview';
export { brandAnalysis } from './brand-analysis';
export { contentDistribution } from './content-distribution';
export { simplifiedAreaComparison } from './simplified-area-comparison';
export { consumerPreference } from './consumer-preference';
export { areaComparison } from './area-comparison';
export { methodology } from './methodology';
export { sentimentAnalysis } from './sentiment-analysis';
export { brandIndex } from './brand-index';

// Export new sample data files
export { categoryAnalysis } from './category-analysis';
export { consumerInsights } from './consumer-insights';
export { aiContentIndex } from './ai-content-index';
export { contentCreation } from './content-creation';
export { performanceTracking } from './performance-tracking';
export { aiVisibilityIndex } from './ai-visibility-index';
export { sampleAICitationsData } from './ai-citations';

// Export AI Courses sample data
export { aiCoursesSearch } from './ai-courses-search';
export { aiCoursesCompare } from './ai-courses-compare';
export { aiCoursesRecommendations } from './ai-courses-recommendations';

// Sample data mapping for easy access
export const sampleEducationData = {
  'overview': 'overview',
  'brand-analysis': 'brandAnalysis',
  'content-distribution': 'contentDistribution',
  'simplified-area-comparison': 'simplifiedAreaComparison',
  'consumer-preference': 'consumerPreference',
  'area-comparison': 'areaComparison',
  'methodology': 'methodology',
  'sentiment-analysis': 'sentimentAnalysis',
  'sentiment-tracking': 'sentimentAnalysis',
  'brand-index': 'brandIndex',
  'category-analysis': 'categoryAnalysis',
  'consumer-insights': 'consumerInsights',
  'ai-content-index': 'aiContentIndex',
  'content-creation': 'contentCreation',
  'performance-tracking': 'performanceTracking',
  'ai-visibility-index': 'aiVisibilityIndex',
  'ai-citations': 'sampleAICitationsData',
  'ai-courses-search': 'aiCoursesSearch',
  'ai-courses-compare': 'aiCoursesCompare',
  'ai-courses-recommendations': 'aiCoursesRecommendations',
  'all-in-one': 'allInOneData'
};
